export default __webpack_public_path__ + "static/media/github.63a78ed4.jpeg";